import React, { useState, forwardRef } from 'react';
import { cx } from "@/utils/cx";
import { Icons } from "@/assets";

export interface BaseInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    isError?: boolean;
    rightElement?: React.ReactNode; // For Password Toggle or Custom Icons
    containerClassName?: string;
}

export const BaseInput = forwardRef<HTMLInputElement, BaseInputProps>(
    ({ type = "text", className, isError, rightElement, containerClassName, ...props }, ref) => {
        const [showPassword, setShowPassword] = useState(false);
        const isPasswordType = type === 'password';
        const inputType = isPasswordType ? (showPassword ? 'text' : 'password') : type;

        return (
            <div className={cx("flex flex-col gap-3", containerClassName)}>
                <div
                    className={cx(
                        "relative w-full rounded-[10px] p-[1.5px] transition-all duration-200 ease-in-out group",
                        isError
                            ? "bg-[#ff424f]"
                            : "bg-gray-30 focus-within:bg-gradient-to-r focus-within:from-[#00B4EA] focus-within:to-[#8A00FF]",
                        props.disabled && "opacity-60 cursor-not-allowed bg-gray-200"
                    )}
                >
                    <div className="relative flex items-center bg-white rounded-[8.5px] overflow-hidden">
                          {/* <Icons.SearchIcon className="w-5 h-5 text-[#ff424f]" />  */}
                       <input
                            ref={ref}
                            type={inputType}
                            className={cx(
                                "w-full h-[51px] px-4 text-gray-900 text-sm placeholder:text-gray-400 outline-none bg-transparent",
                                className,
                                (rightElement || isError || isPasswordType) && "pr-10", // Add padding if icon exists
                                props.disabled && "cursor-not-allowed bg-gray-50"
                                
                            )}
                            {...props}
                        />

                        {/* Password Toggle Logic */}
                        {isPasswordType && !isError && !rightElement && (
                            <button
                                type="button"
                                onClick={() => setShowPassword(!showPassword)}
                                className="absolute right-4 text-sm text-gray-70 hover:text-gray-900 font-medium transition-colors"
                            >
                                {showPassword ? 'Hide' : 'Show'}
                            </button>
                        )}

                        {/* External Right Element (e.g. Upload Button in Doc Field) */}
                        {rightElement && (
                            <div className="absolute right-4 flex items-center">
                                {rightElement}
                            </div>
                        )}

                        {/* Error Icon (Highest Priority) */}
                        {isError && (
                            <div className="absolute right-4 pointer-events-none flex items-center">
                                <Icons.ErrorIcon className="w-5 h-5 text-[#ff424f]" />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
);

BaseInput.displayName = 'BaseInput';